import getContentModalStyles from '../styles';

const ContentModal = () => {};

export { getContentModalStyles };
export default ContentModal;
